<template>
  <section id="welcome" class="container">
    <div class="container grid col-1-1">
      <div class="gap-20 grid">
        <h1 style="font-size: 28px; font-weight: 400">
          Future platforms with AI are already a reality, create your future
          with us
        </h1>
        <p class="t-1">
          We develop platforms and applications with artificial intelligence
          that change the market and your life.
        </p>
        <router-link to="/about" class="btn-1" style="width: max-content"
          >Learn more</router-link
        >
      </div>
    </div>
    <div class="bg-picture-box">
      <img src="@/assets/server-room.jpg" alt="Video image" />
      <div class="bg-img-fon"></div>
    </div>
  </section>

  <section id="features">
    <div class="container">
      <FeatureComponent
        v-for="(f, i) in features"
        :key="i"
        :title="f.title"
        :description="f.description"
        :page="f.page"
        :icon="f.icon"
      />
    </div>
  </section>

  <section id="solutions">
    <div class="container">
      <div>
        <h3>{{ solutions[selected_solution].title }}</h3>
        <p>{{ solutions[selected_solution].description }}</p>
      </div>
      <div class="btns-box">
        <button
          v-for="(solution, key) in solutions"
          :key="key"
          :class="{
            hovered: key === selected_solution,
          }"
          class="btn-2"
          @click="selected_solution = key"
        >
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"
              ></path>
            </svg>
            {{ solution.title }}
          </p>
          <span></span>
        </button>
      </div>
    </div>
  </section>

  <section id="products">
    <div class="container">
      <div class="logos">
        <button
          v-for="(product, key) in products"
          :key="key"
          :class="{
            hovered: key === selected_product,
          }"
          class="logo-btn btn-2"
          @click="selected_product = key"
        >
          <span></span>
          <img
            :src="require(`@/assets/products/${key === selected_product ? product.pic_active : product.pic}`)"
            :alt="product.title"
          />
        </button>
      </div>

      <div>
        <h3 style="margin: 0px">{{ products[selected_product].title }}</h3>
        <a :href="products[selected_product].page">{{
          products[selected_product].page
        }}</a>
        <p style="padding-top: 30px">
          {{ products[selected_product].description }}
        </p>
      </div>
    </div>
  </section>

  <section id="team">
    <h3>Our Team</h3>
    <div class="container">
      <div v-for="(persone, index) in team" :key="index" class="content">
        <div class="bg"></div>
        <img
          :src="require('@/assets/team/' + persone.pic)"
          :alt="persone.name"
        />
        <div class="persone-info">
          <h4>{{ persone.name }}</h4>
          <h5>{{ persone.position }}</h5>
        </div>
        <div class="soc-pages">
          <a :href="persone.linkedin">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M6.94048 4.99993C6.94011 5.81424 6.44608 6.54702 5.69134 6.85273C4.9366 7.15845 4.07187 6.97605 3.5049 6.39155C2.93793 5.80704 2.78195 4.93715 3.1105 4.19207C3.43906 3.44699 4.18654 2.9755 5.00048 2.99993C6.08155 3.03238 6.94097 3.91837 6.94048 4.99993ZM7.00048 8.47993H3.00048V20.9999H7.00048V8.47993ZM13.3205 8.47993H9.34048V20.9999H13.2805V14.4299C13.2805 10.7699 18.0505 10.4299 18.0505 14.4299V20.9999H22.0005V13.0699C22.0005 6.89993 14.9405 7.12993 13.2805 10.1599L13.3205 8.47993Z"
              ></path>
            </svg>
          </a>
        </div>
        <p>{{ persone.description }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import FeatureComponent from "@/components/FeatureComponent.vue";
export default {
  name: "MainView",
  components: {
    FeatureComponent,
  },
  data() {
    return {
      features: [
        {
          title: "AI/ML",
          description: "Development of multimodal AI and machine learning",
          page: "/features/#ai",
          icon: "ai.png",
        },
        {
          title: "Web3",
          description:
            "Development and implementation of blockchain structures",
          page: "/features/#web3",
          icon: "web3.png",
        },
        {
          title: "Platforms",
          description: "Creating platforms based on AI",
          page: "/features/#platforms",
          icon: "platform.png",
        },
        {
          title: "Apps",
          description: "Creating applications based on AI",
          page: "/features/#apps",
          icon: "app.png",
        },
      ],
      selected_solution: "Proctoring AI",
      solutions: {
        "Proctoring AI": {
          title: "Proctoring AI",
          description:
            "Development and training of artificial intelligence for proctoring, the task of which was to conduct proctoring on the Examinarium platform, checking participants in exams and tests, to identify suspicious actions and attempts to use third-party resources for cheating.",
        },
        "Questions Generator": {
          title: "Questions Generator",
          description:
            "Artificial intelligence developed for the Examinarium platform, designed to generate exam and test scores based on company vacancy data.",
        },
        "Autodetection System": {
          title: "Autodetection System",
          description:
            "An auto-detection system implemented in the Examinarium project, designed to identify user attempts to use third-party sites, applications, artificial intelligence and a number of other services to cheat during the exam.",
        },
        "AI Dietitian": {
          title: "AI Dietitian",
          description:
            "Artificial intelligence developing by and learning on the basis of biological and medical books, which enables it to use a special algorithm to create individual diets for a person.",
        },
        "AI Trainer": {
          title: "AI Trainer",
          description:
            "Artificial intelligence developing and learning, the task of which is to use special algorithms to create an individual training course for the user, taking into account his physical characteristics.",
        },
        "AI Vision Trainer": {
          title: "AI Vision Trainer",
          description:
            "AI Vision Trainer is an improved version of AI Trainer, developing and learning to monitor the user's workout in real time and output information about the correctness of the workout and to give advice.",
        },
      },
      selected_product: "Examinarium",
      products: {
        Examinarium: {
          title: "Examinarium",
          pic: "examinarium.png",
          pic_active: "examinarium.png",
          page: "https://examinarium.net",
          description:
            "Examinarium is an AI platform that automates the process of testing and assessing candidates using video monitoring, text analysis, and hard skills assessment. It allows professionals to participate in open exams for employment and to test their skills. The platform is designed for small, medium, and large companies and organizations that require efficient and automated testing for hiring and training.",
        },
        // Unizone: {
        //   title: "Unizone",
        //   pic: "unizone.png",
        //   pic_active: "unizone_1.png",
        //   page: "https://unizone.am",
        //   description:
        //     "Unizone is an innovative online platform in Armenia that not only allows booking fitness and spa services, but also offers powerful AI-powered tools for a personalized approach to healthy living. AI helps users create customized diets with monitoring of their compliance, generate personalized training programs with tracking of their implementation via streaming, and analyze food photos to assess their nutritional value and calorie content. Unizone aims to become an intelligent assistant for users in achieving their health and fitness goals.",
        // },
      },
      team: [
        {
          pic: "zohrab_menedyan.jpeg",
          name: "Zohrab Menedyan",
          position: "CEO",
          description:
            "Visionary leader driving MBP's pursuit of excellence and innovation.",
          facebook: "https://www.facebook.com/zohrab.menedyan",
        },
        {
          pic: "zhora_margaryan.jpeg",
          name: "Zhora Margaryan",
          position: "CTO",
          description:
            "Architecting MBP's cutting-edge tech backbone and fueling innovation.",
          facebook: "https://www.facebook.com/jhoramargaryan",
          linkedin: "https://www.linkedin.com/in/zhora-margaryan-1b7114341/",
        },
        {
          pic: "arman_tonikyan.jpeg",
          name: "Arman Tonikyan",
          position: "CMO",
          description:
            "Crafting MBP's powerful narrative and amplifying our global voice.",
          facebook: "https://www.facebook.com/armtonikyan",
          linkedin: "https://www.linkedin.com/in/armtonikyan/"
        }
      ],
    };
  },
};
</script>

<style scoped>
#team .soc-pages svg {
  width: 20px;
  height: 20px;
  fill: rgb(var(--m-color));
}
#team .soc-pages {
  position: relative;
  z-index: 1;
  display: flex;
  margin: 30px 0px;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
#team p {
  position: relative;
  z-index: 1;
  padding-left: 25px;
  padding-right: 25px;
  margin-bottom: 25px;
  font-weight: 400;
  font-size: 14px;
  color: #6f8ba4;
  letter-spacing: 0.6px;
  line-height: 26px;
  text-align: center;
}
.persone-info h5 {
  display: block;
  font-weight: 400;
  font-size: 12px;
  color: #e5e9f7;
  letter-spacing: 0.6px;
}
.persone-info h4 {
  display: block;
  font-weight: 400;
  font-size: 16px;
  color: #fff;
  letter-spacing: 0.69px;
  margin-bottom: 3px;
}
.persone-info {
  z-index: 1;

  position: relative;
  width: 100%;
  text-align: center;
  background-color: rgb(var(--m-color));
  padding: 10px 0px;
}
#team .content {
  position: relative;
}
#team .content .bg {
  background: white;
  border-radius: 10px;
  color: #6f8ba4;
  font-family: "Nunito", sans-serif;
  background: #fff;
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.06);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  position: relative;
  margin-bottom: 30px;
  margin-top: 85px;
  width: 100%;
  height: calc(100% - 90px);
  position: absolute;
  z-index: 0;
}
#team h3:first-child {
  text-align: center;
  margin-bottom: 50px;
}
#team img {
  width: 240px;
  border-radius: 20px 50px;
  position: relative;
  z-index: 1;
  left: 50%;
  transform: translate(-50%);
}
#team .container {
  grid-template-columns: repeat(3, 1fr) !important;
  margin: auto;
}

#team .container .content{
  max-width: 360px;
}
#team {
  margin-top: 100px;
}
.logo-btn {
  padding: 10px;
  width: max-content;
  margin: auto;
  width: 100%;
  display: flex;
  justify-content: center;
}
.logo-btn img {
  max-width: 60px;
  max-height: 60px;
  position: relative;
  z-index: 2;
}
#products .logos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 50px;
}
.products-box {
  display: grid;
  gap: 20px;
}
#products {
  padding: 40px 0px;
  display: flex;
  justify-content: center;
}
#solutions .btns-box {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr;
}
#solutions h3,
#team h3,
#products h3 {
  font-weight: 400;
  font-size: 28px;
  color: #3b566e;
  letter-spacing: 1.75px;
  height: 45px;
  margin-bottom: 30px;
  position: relative;
}
#solutions p,
#products p {
  font-weight: 400;
  font-size: 16px;
  color: #6f8ba4;
  line-height: 28px;
  letter-spacing: 1px;
}
#solutions .container,
#team .container {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr;
}
#solutions {
  padding: 80px 0px;
  background: rgba(var(--m-color), 0.1);
  position: relative;
  display: flex;
  height: max-content;
  justify-content: center;
}
#features .container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: auto;
  gap: 20px;
  position: relative;
  top: -50px;
}
#features {
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
}
.bg-img-fon {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  background: rgb(var(--m-color));
  opacity: 0.6;
}
.bg-picture-box img {
  width: 150%;
  height: 150%;
  object-fit: cover;
  top: -100px;
  left: -100px;
  rotate: -25deg;
  position: absolute;
}
.bg-picture-box {
  width: 50vw;
  height: 50vw;
  border-radius: 25px;
  position: absolute;
  right: -100px;
  top: -50px;
  rotate: 25deg;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}
#welcome .container {
  height: max-content;
  position: relative;
  z-index: 2;
  padding: 0px 10px;
}
#welcome {
  position: relative;
  height: 50vw;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0px;
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: hidden;
}
@media (max-width: 1200px) {
  #solutions .container {
    height: max-content;
  }
  #solutions .btns-box {
    grid-template-columns: 1fr;
  }

  #team .container {
    width: calc(100% - 20px);
  }
}
@media (max-width: 1000px) {
  #welcome h1,
  #welcome p {
    text-align: center;
    color: white;
  }
  #welcome {
    height: 70vh;
  }
  #welcome .btn-1 {
    margin: auto;
  }
  .bg-picture-box {
    border-radius: 0px;
    position: absolute;
    right: 0px;
    top: 0px;
    rotate: 0deg;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  .bg-picture-box img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    top: 0px;
    left: 0px;
    rotate: 0deg;
    position: absolute;
  }
  #features .container {
    grid-template-columns: repeat(2, 1fr);
    top: 0px;
    margin: 20px 0px;
  }
}
@media (max-width: 800px) {
  #solutions .container {
    grid-template-columns: 1fr;
  }
  #products .logos {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  #team img {
    width: 180px;
  }
  #team .container {
    grid-template-columns: repeat(1, 1fr) !important;
    width: calc(100% - 20px);
  }
  #team .container .content{
    margin: auto;
  }
}
@media (max-width: 500px) {
  #features .container {
    grid-template-columns: repeat(1, 1fr);
  }
  #team .container {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
</style>
